module.exports = __webpack_public_path__ + "img/icon_gnb_arrow_open.e9a6e48b.svg";